'use client';

import { ReactNode } from 'react';

export function EnvCheck({ children }: { children: ReactNode }) {
  // Only check in production - allow local development with fallbacks
  const isProduction = process.env.NODE_ENV === 'production';

  // Check for required environment variables (only in production)
  const missingVars: string[] = [];

  if (isProduction) {
    if (!process.env.NEXT_PUBLIC_API_URL) {
      missingVars.push('NEXT_PUBLIC_API_URL');
    }
    if (!process.env.NEXT_PUBLIC_SUPABASE_URL) {
      missingVars.push('NEXT_PUBLIC_SUPABASE_URL');
    }
    if (!process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY) {
      missingVars.push('NEXT_PUBLIC_SUPABASE_ANON_KEY');
    }
  }

  if (missingVars.length > 0) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8">
        <div className="max-w-2xl w-full bg-red-50 border border-red-200 rounded-lg p-6">
          <h1 className="text-2xl font-bold text-red-900 mb-4">Configuration Error</h1>
          <p className="text-red-800 mb-4">
            Missing required environment variables. Please set the following in your Vercel project
            settings:
          </p>
          <ul className="list-disc list-inside space-y-2 text-red-700 mb-4">
            {missingVars.map((varName) => (
              <li key={varName} className="font-mono">
                {varName}
              </li>
            ))}
          </ul>
          <p className="text-sm text-red-600">
            Go to Vercel Dashboard → Your Project → Settings → Environment Variables
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
